// Librerias
import Vue from "vue";
import Vuex from "vuex";
import { urlConsultasFirestore } from "@/firebase";
import { arreglos, colecciones, ruta } from "./constantes";
import {
  privilegios,
  usuario,
  control,
  vinculacion,
  guia,
  profesiograma,
  categoriaCargo,
  examenCargo,
  cargoProfesiograma,
  conductor,
  vehiculo,
  evento,
  inspeccion,
  inspeccionExento,
  mantenimiento,
  planDesplazamiento,
  notificacion,
  rutograma,
  aptitudes,
  ticket,
  planAccion,
  formatos,
  cuestionarios,
  infografia,
  agendaPlanBusiness,
  siniestro,
} from "./modelos";
import {
  funcionesGenerales,
  funcionesOffline,
  funcionesUsuarios,
  funcionesEmpresas,
  funcionesConductores,
  funcionesVehiculos,
  funcionesInspecciones,
  funcionesPlanDesplazamiento,
  funcionesCapacitaciones,
  funcionesExcel,
  funcionesStorage,
} from "./funciones";

// import { isBoolean } from 'lodash'
// Vue usa
Vue.use(Vuex);

// Global Store
export default new Vuex.Store({
  state: {
    // Dominio de pruebas
    // https://riskmanndev.web.app/
    // Dominio de desarrollo
    // http://localhost:8080
    // Dominio temporal para compartir
    // https://rm202408300352pm.web.app/
    // Variables de uso global
    idEmpresaSeleccionada: "",
    ruta: ruta,
    rutaStorageEmpresas: `files/empresas`,
    // version actual del sistema
    version: "Versión | 2026.11.01.02.50.a.m.",
    versiones: {
      antigua: {
        nombre: "Versión | 2026.10.27.08.55.p.m.",
        detalles: [
          {
            titulo: "Carga las inspecciones que se hicieron en papel",
            descripcion: "En Seguridad Vial › Inspecciones, con Cargar inspección en papel, pasas a RiskMann una inspección con la fecha y la hora del papel y el resultado que quedó en él. Si el vehículo o el conductor no están, los registras ahí mismo, con sus documentos. Si tienes el papel escaneado, lo adjuntas como soporte y queda en el detalle de la inspección.",
            tipo: "Nueva Característica",
          },
        ],
      },
      nueva: {
        nombre: "Versión | 2026.11.01.02.50.a.m.",
        detalles: [
          {
            titulo: "Conductores: sabes cuándo un dato no alcanzó a cargar",
            descripcion: "En Conductores activos e inactivos, si el nombre, el documento o la ciudad de un conductor no alcanzan a cargar, por ejemplo con una conexión lenta, la fila dice «No cargó» y un aviso te ofrece Volver a intentar. El guion (-) indica un dato vacío, y el dispositivo o cliente siempre está a la vista.",
            tipo: "Mejora",
          },
          {
            titulo: "Editar Perfil espera a que termine de guardar",
            descripcion: "Mientras se guardan los cambios, la ventana se queda abierta y el botón dice «Guardando…». Al terminar, se cierra y te confirma que todo quedó guardado.",
            tipo: "Mejora",
          },
          {
            titulo: "Vehículos del conductor, con aviso si la conexión está lenta",
            descripcion: "En la hoja de vida del conductor, si sus vehículos no alcanzan a cargar, te avisamos y puedes cargarlos con Volver a intentar. Mientras no carguen, no se puede cambiar la lista, para cuidar los vehículos que el conductor ya tiene asignados.",
            tipo: "Mejora",
          },
          {
            titulo: "Del registro en riskmann.com al inicio de sesión, con tu correo escrito",
            descripcion: "Cuando creas tu cuenta en riskmann.com, al llegar a iniciar sesión tu correo ya está escrito y solo te falta la contraseña.",
            tipo: "Mejora",
          },
        ],
      },
    },
    colecciones: { ...colecciones },
    id_usuario: "",
    imagenes: {
      defecto: {
        foto: require("@/assets/img/general_foto_perfil_defecto.webp"),
        portada: require("@/assets/img/general_foto_portada_defecto.webp"),
        vehiculo: require("@/assets/img/seguridad_vial_vehiculo_foto_defecto.webp"),
        notificacion: require("@/assets/img/notificacion_icono_defecto.webp"),
        evento: require("@/assets/img/eventos_ilustracion_defecto.webp"),
      },
    },
    apis: {
      firebase: {
        firestore: urlConsultasFirestore,
      },
    },
    // ── Asistente IA (Riskmann IA) ─────────────────────────────────────────
    // El PanelChat escribe `prefill` al recibir un ui_action "preparar_registro";
    // el formulario correspondiente lo consume en su init y lo limpia.
    // El asistente NUNCA crea registros: solo prellena y el usuario confirma.
    asistenteIA: {
      prefill: null, // { formulario: "inspeccion"|"siniestro"|..., campos: {...} }
      // Pregunta llegada por ?asistente= (derivación desde el Campus):
      // App.vue la captura y AsistenteIA.vue la consume al montarse.
      preguntaPendiente: null,
      consumirPrefill(formulario) {
        const prefill = this.prefill;
        if (!prefill || prefill.formulario !== formulario) return null;
        this.prefill = null;
        return prefill.campos || {};
      },
      // Aplica campos sobre el objeto del modelo SOLO si la clave ya existe
      // (soporta un nivel anidado "a.b") y no pisa sub-objetos con escalares.
      aplicarCampos(vm, objetivo, campos) {
        for (const clave of Object.keys(campos || {})) {
          const partes = clave.split(".");
          let nodo = objetivo;
          let valido = true;
          for (let i = 0; i < partes.length - 1; i++) {
            if (nodo && typeof nodo === "object" && partes[i] in nodo) {
              nodo = nodo[partes[i]];
            } else {
              valido = false;
              break;
            }
          }
          const ultima = partes[partes.length - 1];
          if (
            valido &&
            nodo &&
            typeof nodo === "object" &&
            ultima in nodo &&
            (typeof nodo[ultima] !== "object" || nodo[ultima] === null)
          ) {
            vm.$set(nodo, ultima, campos[clave]);
          }
        }
      },
    },
    // Modelos de cada módulo (clases y funciones): están en src/store/modelos/
    privilegios,
    usuario,
    control,
    vinculacion,
    guia,
    arreglos: { ...arreglos },
    profesiograma,
    categoriaCargo,
    examenCargo,
    cargoProfesiograma,
    conductor,
    vehiculo,
    evento,
    inspeccion,
    inspeccionExento,
    mantenimiento,
    planDesplazamiento,
    notificacion,
    rutograma,
    aptitudes,
    ticket,
    planAccion,
    formatos,
    cuestionarios,
    infografia,
    agendaPlanBusiness,
    siniestro,
    // Funciones globales (this.$store.state.obtenerUsuario…): están en src/store/funciones/
    ...funcionesGenerales,
    ...funcionesOffline,
    ...funcionesUsuarios,
    ...funcionesEmpresas,
    ...funcionesConductores,
    ...funcionesVehiculos,
    ...funcionesInspecciones,
    ...funcionesPlanDesplazamiento,
    ...funcionesCapacitaciones,
    ...funcionesExcel,
    ...funcionesStorage,
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
